import { FILTER_OPTIONS } from '@/constants/initiative'

export const FieldType = {
  SIMPLE: 'simple',
  USER: 'user',
  TEAM: 'team',
  DATETIME: 'datetime',
  DATE: 'date',
  BOOL: 'bool',
  TEXT: 'text',
  DROPDOWN: 'dropdown',
  NUMBER: 'number',
  GOAL: 'goal',
  KEY_RESULT: 'key_result'
}

export const fieldTypeOperatorMapping = {
  default: {
    is: {
      fieldLabel: '=',
      label: 'is'
    },
    'not-is': {
      label: 'is not',
      fieldLabel: '!='
    },
    in: {
      fieldLabel: '=',
      label: 'is'
    },
    'not-in': {
      label: 'is not',
      fieldLabel: '!='
    },
    set: {
      fieldLabel: 'is set',
      label: 'is set'
    },
    'not-set': {
      label: 'is not set',
      fieldLabel: 'is not set'
    },
    lt: {
      fieldLabel: '<',
      label: 'is less than'
    },
    gt: {
      fieldLabel: '>',
      label: 'is greater than'
    },
    lte: {
      fieldLabel: '<=',
      label: 'is less than or equal'
    },
    gte: {
      fieldLabel: '>=',
      label: 'is greater than or equal'
    }
  },
  [FieldType.DATE]: {
    lt: {
      fieldLabel: '<',
      label: 'is before'
    },
    gt: {
      fieldLabel: '>',
      label: 'is after'
    },
    lte: {
      fieldLabel: '<=',
      label: 'is on or before'
    },
    gte: {
      fieldLabel: '>=',
      label: 'is on or after'
    }
  }
}

export const Operator = {
  IS: 'is',
  NOT_IS: 'not-is',
  IN: 'in',
  NOT_IN: 'not-in',
  LT: 'lt',
  GT: 'gt',
  LTE: 'lte',
  GTE: 'gte',
  SET: 'set',
  NOT_SET: 'not-set'
}

export const dateFieldOptions = [
  {
    id: Operator.IS,
    fieldLabel: '=',
    label: 'is'
  },
  {
    id: Operator.LT,
    fieldLabel: '<',
    label: 'is before'
  },
  {
    id: Operator.GT,
    fieldLabel: '>',
    label: 'is after'
  },
  {
    id: Operator.LTE,
    fieldLabel: '<=',
    label: 'is on or before'
  },
  {
    id: Operator.GTE,
    fieldLabel: '>=',
    label: 'is on or after'
  }
]

export const InitiativeFieldId = {
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
  OWNER: 'owner',
  PRIMARY_OWNER: 'primary_owner',
  TEAM: 'team',
  IS_CLOSED: 'is_closed',
  CLOSED_ON: 'closed_on',
  PRIORITY: 'impact',
  STATUS: 'status',
  PROJECT: 'project',
  DUE_DATE: 'due_date',
  COMMENT_COUNT: 'comment_count',
  LAST_COMMENT_ON: 'last_comment_on',
  CREATED_BY: 'created_by',
  COMPLETED_BY: 'completed_by',
  GOAL: 'goal',
  KEY_RESULT: 'key_result',
  IS_ARCHIVED: 'is_archived',
  NEW_PRIORITY: 'priority',
  LAST_UPDATED_BY: 'last_updated_by',
  LAST_COMMENT_UPDATE_ON: 'last_comment_update_on',
  LAST_MENTION_ON: 'last_mention_on'
}

export const CARDINALITY = {
  ONE: 'one',
  MANY: 'many',
  ZERO: 'zero'
}

export const FIELD_OPTIONS_MAP = {
  [InitiativeFieldId.STATUS]: FILTER_OPTIONS.status,
  [InitiativeFieldId.PRIORITY]: FILTER_OPTIONS.priority,
  [InitiativeFieldId.NEW_PRIORITY]: FILTER_OPTIONS.priority
}
export const FIELD_NQL_OPTIONS_MAP = {
  [InitiativeFieldId.STATUS]: FILTER_OPTIONS.status.map(status => ({
    ...status,
    id: status.label
  })),
  [InitiativeFieldId.NEW_PRIORITY]: FILTER_OPTIONS.priority.map(priority => ({
    ...priority,
    id: priority.label
  }))
}
